import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Grid, Paper, Stack, Typography, Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { dateFormatter, getMonthYear } from '../../../../../utils';
import axios from 'axios';
import { GRN_CNT } from '../../../../../constants/dropdown';

const GRN_HEADER = [
  {
    header: 'Invoice No.',
    accessor: 'cnt'
  },
  {
    header: 'Supplier',
    accessor: (row) => row?.supplier?.ledger_name
  },
  {
    header: 'Location',
    accessor: (row) => row?.location?.warehouse_name
  }
];

const GRN_DETAILS_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => row?.product?.main?.name
  },
  {
    header: 'Unit',
    accessor: 'unit'
  },
  {
    header: 'Bill Qty',
    accessor: 'bill_qty'
  },
  {
    header: 'Free Qty',
    accessor: 'free_qty'
  },
  {
    header: 'Rate',
    accessor: 'rate'
  },
  {
    header: 'Discount',
    accessor: 'dis_amt'
  },
  {
    header: 'Batch',
    accessor: 'batch_no'
  },
  {
    header: 'Stock',
    accessor: 'total_qty'
  },
  {
    header: 'Expiry',
    accessor: (row) => getMonthYear(row?.exp_date)
  }
];


const PRODUCT_DETAILS_HEADER = [
  {
    header: 'GRN/CR',
    accessor: (row) => row?.productDetails?.challan_no
  },
  {
    header: 'Product Name',
    accessor: (row) => row?.productDetails?.productInfo?.main?.name
  },
  {
    header: 'Supplier',
    accessor: (row) => row?.productDetails?.supplier?.ledger_name
  },
  {
    header: 'Unit',
    accessor: (row) => row?.productDetails?.productInfo?.main?.purchasing_unit_info?.unit_name
  },
  {
    header: 'Rate',
    accessor: (row) => row?.productDetails?.rate
  },
  
  {
    header: 'Batch',
    accessor: (row) => row?.productDetails?.batch_no
  },
  {
    header: 'Current Stock',
    accessor: (row) => row?.productDetails?.total_qty
  },
  {
    header: 'Expiry',
    accessor: (row) => getMonthYear(row?.productDetails?.exp_date)
  },
];


export const GrnAuthorize = () => {
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [selectedProduct, setSelectedProduct] = useState(false);
  const [productDetails, setProductDetails] = useState([]);
  const [mergedData, setMergedData] = useState([]);
  const [stock, setStock] = useState([]);
  const { pathname } = useLocation();
  const[totalStocks,setTotalStocks] = useState([])
  const [docNo, setDocNo] = useState(""); // Add this state
  const [againstConsignment,setAgainstConsignment] = useState(false)
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const user = JSON.parse(localStorage.getItem('user'));

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: getCurrentDateTime('date'),
      time: getCurrentDateTime('time'),
      bill: {
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });

  const { handleSubmit, reset, setValue ,watch} = methods;
  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setValue('uhid', selectedRecord.uhid);
      setDetailList(selectedRecord.service_items);
      setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
      setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
    } else {
      reset();
    }
  }, [selectedRecord]);

  const watchgrncnt = watch('cnt_grn')
  const getGrnAndConsignmentData = useCallback(async () => {
    try {
      let grnData = [];
      let consignmentData = [];
      if (watchgrncnt === 'cnt') {
        consignmentData = await dropdownFetch('consignment-receipt-unauthorise');
      } else if (watchgrncnt === 'grn') {
        grnData = await dropdownFetch('grn-unauthorise');
      } else {
        grnData = await dropdownFetch('grn-unauthorise');
        consignmentData = await dropdownFetch('consignment-receipt-unauthorise');
      }
      const merged = [...grnData, ...consignmentData];
      setMergedData(merged);
      setSelectedProduct(merged);
      setSelectedProduct(true);
    } catch (error) {
      console.error('Error fetching or processing data:', error);
    }
  }, [watchgrncnt]);


  useEffect(() => {
    getGrnAndConsignmentData();
  }, [getGrnAndConsignmentData]);


const handleRowClick = (row) => {
  console.log(row, "HELLO ROW IS HERE ....");
    let type = row.type;
  if (row.cnt?.startsWith("GRN")) {
    type = "Purchase";
  } else if (row.cnt?.startsWith("CNT")) {
    type = "Consignment";
  }
  setAgainstConsignment(row.type === "Against Consignment");
  const updatedProductDetails = row.add_details.map((detail) => ({
    ...detail,
    cnt: row.cnt,
    location: row.location,
    supplier: row.supplier,
    challan_no: row.cnt,
    type: type,
  }));
  setDocNo(row.cnt);
  setProductDetails(updatedProductDetails);
};

  const formSubmit = async () => {
    if(productDetails.length === 0 ){
      toast("First Select The Consignment or GRN", { variant:"warning" } )
      return
    }
    setLoading(true);
    const updatedProductDetails = productDetails.map((productDetail) => ({
      ...productDetail,
      product: productDetail.product?._id,
      hsn_code: productDetail.hsn_code,
      conversion: productDetail.conversion,
      mrp: productDetail.conversion ? (productDetail.mrp / productDetail.conversion) : 0,
      supplier: productDetail.supplier,
      unit: productDetail.unit,
      bill_qty: productDetail.bill_qty,
      packing: productDetail.packing,
      free_qty: productDetail.free_qty,
      rate: productDetail.conversion ? (productDetail.rate / productDetail.conversion) : 0,
      gst: productDetail.gst,
      dis_amt: productDetail.dis_amt,
      dis_percent: productDetail.dis_percent,
      batch_no: productDetail.batch_no,
      total_qty: productDetail.total_qty,
      mfg_date: productDetail.mfg_date,
      exp_date: productDetail.exp_date,
      inQty : Number(productDetail.total_qty || 0),
      outQty : Number(0),
      purRate : productDetail.conversion ? (Number(productDetail.rate) / Number(productDetail.conversion)) : 0,
      saleRate : productDetail.conversion ? (Number(productDetail.sal_rate) / Number(productDetail.conversion)) : 0,
      purAmount : Number(productDetail.amount || 0),
      type : productDetail.type || "",
      saleAmount : Number(productDetail.amount || 0),
    }));

    const payload = {
      doc_no : docNo,
      productDetails: updatedProductDetails
    };
    console.log(payload,"PAYLOAD IS HERE !")

      const apiEndpoint = againstConsignment
    ? "/stock-master-against-consignment-create"
    : "/stock-master-create";

    try {
      const response = await request(apiEndpoint, {
        method: 'POST',
        body: {
          ...payload,
          createdBy: user.name,
          organisation
        }
      });
      if (response?.success) {
        toast('Stock details successfully submitted to StockMaster!', { variant: 'success' });
        getGrnAndConsignmentData();
        setProductDetails([]);
        setStock([])
      } else {
        throw new Error('Failed to submit stock details.');
      }
    } catch (error) {
      toast(`Error: ${error.message}`, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };



  const fetchStock = async () => {
    const response = await request('/stock-master-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setStock({ loading: false, data: sortedData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setStock({ loading: false });
    }
  };

  useEffect(() => {
    fetchStock();
  }, []);

  const handleRowProduct = (row) => {
    fetchStocks(row?.product?._id)
  };

  const fetchStocks = async (rowId) => {
    const response = await axios.get(`${BASE_URL}/stock-master/total?name=${rowId}`);
    if (response?.data?.success) {
      const totalQuantity = response.data.data;
      const totalQuantitySum = totalQuantity.reduce((sum, item) => sum + item.totalQuantity, 0);
      setStock(totalQuantity);
      setTotalStocks(totalQuantitySum);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setStock({ loading: false, data: [] });
    }
  };

  console.log(productDetails,"PRODUCT DETAIL IS HERE !")
  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Purchase Authorize
              </Typography>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Stack sx={{ flex: 1  ,marginBottom:2}} spacing={0.5} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.05, fontWeight: 700, fontSize: '1.4rem' }}>GRN/CNT</Typography>
                <SelectTag
                  formControlSX={{ flex: 0.29 }}
                  name="cnt_grn"
                  placeholder="Select CNT/GRN"
                  menus={GRN_CNT}
                />
              </Stack>
              <Grid container spacing={2}>
                {/* First Table */}
                <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Table
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={mergedData || []}
                    columns={GRN_HEADER}
                    size="small"
                    onRowClick={handleRowClick}
                    showAuthorize={true}
                    onAuthorizeHandler={formSubmit}
                  />
                </Grid>
                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Table
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={productDetails || []}
                    columns={GRN_DETAILS_HEADER}
                    size="small"
                    onRowClick={(row) => {
                      handleRowProduct(row);
                    }}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, marginTop: '2%' }}>
                <Table
                  containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                  data={Array.isArray(stock) ? stock : []} // Ensure stock is an array
                  columns={PRODUCT_DETAILS_HEADER}
                  size="small"
                />
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
